import React from 'react'
import * as Style from './CourseGoal.module.scss'
import Button from '../UI/button/Button'

const CourseGoal = ({info}) => {
  return (
    <div className={Style.wrapper}>
        <h2 className={Style.title}>{info.title}</h2>
        <p className={Style.description}>{info.description}</p>
        <Button style={Style.btn}>{info.button.button_title}</Button>
    </div>
  )
}

export default CourseGoal